"use client"
import { Link, type LinkProps } from "@opensea/next-ui-kit"
import { useTrackHomePageNavigation } from "@/hooks/use-track-home-page-navigation"

type HomeLinkProps = Omit<LinkProps, "href" | "onNavigationCompleted">

export function HomeLink(rest: HomeLinkProps) {
  const trackHomePageNavigation = useTrackHomePageNavigation()
  return (
    <Link href="/" onNavigationCompleted={trackHomePageNavigation} {...rest} />
  )
}
